import StoreCouponsPage from 'components/pages/Store';

import { toStoreCouponsLink } from 'lib/links';
import { resolvify } from 'lib/promises';

import { getActiveAdsByStore, getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import { getLandingsList } from 'services/landing';
import {
  getPopularStoresListWithOffersCount,
  getStoreCouponsList,
  getStoreInfo,
  getStoreOffersList,
  getStoresList,
} from 'services/store';

import APP from 'constants/app';
import COUPONS from 'constants/coupons';
import LINKS from 'constants/links';
import STORES from 'constants/store';

const OFFERS_SERVER_LIMIT = 24;

const StoreCoupons = (props) => (
  <StoreCouponsPage {...props} serverOffers={null} />
);

export const getServerSideProps = async ({ params: { storeSlug } }) => {
  /**
   * This resolves the retroactive of some 404 errors when some slugs going
   * with unwanted whitespaces.
   */
  if (storeSlug.trim() !== storeSlug) {
    return {
      redirect: { destination: toStoreCouponsLink(storeSlug), permanent: true },
    };
  }

  try {
    const [
      store,
      serverOffers,
      serverCoupons,
      popularStores,
      featuredStores,
      storeAd,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getStoreInfo({ storeSlug }),
      getStoreOffersList({ limit: OFFERS_SERVER_LIMIT, storeSlug }),
      getStoreCouponsList({ storeSlug, limit: COUPONS.COUPONS_LIMIT }),
      {
        fn: getPopularStoresListWithOffersCount({
          limit: STORES.POPULAR_STORES_LIMIT,
        }),
        fallback: getPopularStoresListWithOffersCount.fallback,
      },
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getActiveAdsByStore({ storeSlug }),
        fallback: getActiveAdsByStore.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    /**
     * As the url for the Promobit store is different `LINKS.PROMOBIT_COUPONS`
     * and not /cupons/loja/promobit we do this redirect to keep it consistent.
     */
    if (store.storeId === STORES.PROMOBIT_STORE_ID) {
      return {
        redirect: { destination: LINKS.PROMOBIT_COUPONS, permanent: true },
      };
    }

    return {
      props: {
        featuredStores,
        popularStores: popularStores || [],
        serverCoupons,
        serverOffers,
        store,
        storeAd,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default StoreCoupons;
